import { render } from "./ConsentSettingsLink.vue?vue&type=template&id=51afaacf"
import script from "./ConsentSettingsLink.vue?vue&type=script&lang=js"
export * from "./ConsentSettingsLink.vue?vue&type=script&lang=js"
script.render = render

export default script